import { api } from './api';

export const notificationApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: (payload) => ({
                url: '/api/notification/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['NotificationList']
        }),
        updateNotifications: builder.mutation({
            query: (payload) => ({
                url: '/api/notification/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'UPDATE'
                }
            }),
            invalidatesTags: ['NotificationList', 'NotificationListInfinite']
        }),
        infiniteNotifications: builder.query({
            query: (payload) => ({
                url: '/api/notification/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            serializeQueryArgs: ({ endpointName }) => endpointName,
            merge: (currentCache, newData, { arg }) => {
                const currentPage = arg?.pagination?.current_page || newData?.pagination?.current_page || 1;

                if (currentPage <= 1) {
                    Object.assign(currentCache, newData);
                    return;
                }

                const mergedFields = [...(currentCache?.fields || []), ...(newData?.fields || [])].filter(
                    (item, index, array) => index === array.findIndex((notification) => notification?.id === item?.id)
                );

                Object.assign(currentCache, {
                    ...newData,
                    fields: mergedFields
                });
            },
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg;
            },
            providesTags: ['NotificationListInfinite']
        }),
        deleteNotification: builder.mutation({
            query: (payload) => ({
                url: '/api/notification/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'REMOVE'
                }
            }),
            invalidatesTags: ['NotificationList', 'NotificationListInfinite']
        })
    })
});

export const { useGetNotificationsQuery, useInfiniteNotificationsQuery, useUpdateNotificationsMutation, useDeleteNotificationMutation } =
    notificationApi;
